import React, {useEffect, useState} from "react";
import {ProfileEducationForm} from "../profile-forms/ProfileEducationForm";
import {ProfileExperienceForm} from "../profile-forms/ProfileExperienceForm";
import {ProfileLanguageForm} from "../profile-forms/ProfileLanguageForm";
import {ProfileAdditionalQualificationForm} from "../profile-forms/ProfileAdditionalQualificationForm";
import {ProfileScientificPaperForm} from "../profile-forms/ProfileScientificPaperForm";
import {ProfileFieldOfInterestForm} from "../profile-forms/ProfileFieldOfInterestForm";
import {ProfileSkillForm} from "../profile-forms/ProfileSkillForm";
import {ProfileItSkillForm} from "../profile-forms/ProfileItSkillForm";
import {ProfileDocumentForm} from "../profile-forms/ProfileDocumentForm";
import {ProfileAdditionalInformationForm} from "../profile-forms/ProfileAdditionalInformationForm";
import {ProfilePersonalInformationForm} from "../profile-forms/ProfilePersonalnformationForm";
import {ProfileImageForm} from "../profile-forms/ProfileImageForm";
import {ProfileDrivingLicenseForm} from "../profile-forms/ProfileDrivingLicenseForm";

function ProfileDrivingLicenseSegmentForm(props) {
    return null;
}

ProfileDrivingLicenseSegmentForm.propTypes = {};
export const GenericEditModalForm = ({entity, setEntity, title, type, updateEntity, setUpdateEntity, setAddEntity,updateCandidate, setUpdateCandidate}) => {

    const [segment, setSegment] = useState();

    useEffect(()=> {
        if(type === 'PERSONAL_INFORMATION') {
            setSegment(<ProfilePersonalInformationForm
                entityTemp={entity}
                setEntityTemp={setEntity}
                title={title}
                updateEntity={updateEntity}
                setUpdateEntity={setUpdateEntity}
                setAddEntity={setAddEntity}/>)
        } else if(type==='EDUCATION'){
            setSegment(<ProfileEducationForm
                entityTemp={entity}
                setEntityTemp={setEntity}
                title={title}
                updateEntity={updateEntity}
                setUpdateEntity={setUpdateEntity}
                setAddEntity={setAddEntity}
            />)
        } else if(type === 'FIELD_OF_INTEREST'){
            setSegment(<ProfileFieldOfInterestForm
                entityTemp={entity}
                setEntityTemp={setEntity}
                title={title}
                updateEntity={updateEntity}
                setUpdateEntity={setUpdateEntity}
                setAddEntity={setAddEntity}
            />)
        } else if(type === 'EXPERIENCE'){
            setSegment(<ProfileExperienceForm
                entityTemp={entity}
                setEntityTemp={setEntity}
                title={title}
                updateEntity={updateEntity}
                setUpdateEntity={setUpdateEntity}
                setAddEntity={setAddEntity}
            />)
        } else if(type === 'LANGUAGE'){
            setSegment(<ProfileLanguageForm
                entityTemp={entity}
                setEntityTemp={setEntity}
                title={title}
                updateEntity={updateEntity}
                setUpdateEntity={setUpdateEntity}
                setAddEntity={setAddEntity}
            />)
        } else if(type === 'SCIENTIFIC_PAPER'){
            setSegment(<ProfileScientificPaperForm
                entityTemp={entity}
                setEntityTemp={setEntity}
                title={title}
                updateEntity={updateEntity}
                setUpdateEntity={setUpdateEntity}
                setAddEntity={setAddEntity}
            />)
        } else if(type === 'SKILL'){
            setSegment(<ProfileSkillForm
                entityTemp={entity}
                setEntityTemp={setEntity}
                title={title}
                updateEntity={updateEntity}
                setUpdateEntity={setUpdateEntity}
                setAddEntity={setAddEntity}
            />)
        } else if(type === 'IT_SKILL'){
            setSegment(<ProfileItSkillForm
                entityTemp={entity}
                setEntityTemp={setEntity}
                title={title}
                updateEntity={updateEntity}
                setUpdateEntity={setUpdateEntity}
                setAddEntity={setAddEntity}
            />)
        } else if(type === 'DRIVING_LICENSE'){
            setSegment(<ProfileDrivingLicenseForm
                entityTemp={entity}
                setEntityTemp={setEntity}
                title={title}
                updateEntity={updateEntity}
                setUpdateEntity={setUpdateEntity}
                setAddEntity={setAddEntity}
            />)
        } else if(type === 'ADDITIONAL_QUALIFICATION'){
            setSegment(<ProfileAdditionalQualificationForm
                entityTemp={entity}
                setEntityTemp={setEntity}
                title={title}
                updateEntity={updateEntity}
                setUpdateEntity={setUpdateEntity}
                setAddEntity={setAddEntity}
            />)
        } else if(type === 'DOCUMENT'){
            setSegment(<ProfileDocumentForm
                entityTemp={entity}
                setEntityTemp={setEntity}
                title={title}
                updateEntity={updateEntity}
                setUpdateEntity={setUpdateEntity}
                setAddEntity={setAddEntity}
            />)
        } else if(type === 'IMAGE'){
            setSegment(<ProfileImageForm
                entityTemp={entity}
                setEntityTemp={setEntity}
                title={title}
                updateEntity={updateEntity}
                setUpdateEntity={setUpdateEntity}
                setAddEntity={setAddEntity}
            />)
        } else if(type === 'ADDITIONAL_INFORMATION'){
            setSegment(<ProfileAdditionalInformationForm
                entityTemp={entity}
                setEntityTemp={setEntity}
                title={title}
                updateEntity={updateEntity}
                setUpdateEntity={setUpdateEntity}
                setAddEntity={setAddEntity}
                setUpdateCandidate={setUpdateCandidate}
                updateCandidate={updateCandidate}
            />)
        }
    }, [])

    return    (
        <div>
            {segment}
        </div>
    )

}